export const Error = () => {
    return(
        <div className="noresult">
            <div className="text-center">
                <hr style={{color: "red"}}/>
                <h5 className="mt-2" style={{color: "red"}}>Something went wrong. Try Reloading the page.</h5>
            </div>
        </div>
    )
}